import { Button, Dialog, TextField, FormControl, InputLabel, Select, MenuItem, InputAdornment, IconButton } from "@mui/material";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { useSnackbar } from "notistack";
import { ProjectConfig } from 'Global';
import ISwitch from "elements/ISwitch";
import ImageUploader from "elements/ImageUploader";
import { PiUploadSimpleLight, PiEyeLight, PiEyeSlash } from "react-icons/pi";
import { Dropdown, Form } from 'semantic-ui-react';

export default function UsersEditor(props: any) {
  const {
    setLoading, 
    openEditor, 
    setOpenEditor, 
    user_id,
    loadList,
    company_id = null
  } = props;

  const { enqueueSnackbar } = useSnackbar();

  const defaultValues: any = {
    user_id: user_id ? user_id : "null",
    name: "",
    lastname: "",
    phone: "",
    email: "",
    password: "",
    is_active: true,
    role_id: 101, 
    company_id: company_id,
    zone_id: 0,
    image: "", // Added for storing user image
  };
  
  const [formValues, setFormValues] = useState(defaultValues);
  const [files, setFiles] = useState<any>(null);
  const [showPassword, setShowPassword] = useState(false);

  //clear form values when editor is closed
  useEffect(() => {
    if (!openEditor) {
      setFormValues(defaultValues);
    }
  }, [openEditor]);

  useEffect(() => {
    if (user_id && openEditor) {
      axios.get(ProjectConfig.api_url + "/users/details", {
          headers: {
            "ltkn": localStorage.getItem('ltkn')
          },
          params: {
            user_id: user_id,
          },
        })
        .then((response) => {
          setFormValues(response.data);
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    } else {
      setFormValues(defaultValues);
    }
  }, [user_id, openEditor]);

  const handleInputChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const triggerFileInput = () => {
    const inputElement = document.querySelector('.user_editor_wrapper input[type="file"]');
    if (inputElement) (inputElement as HTMLInputElement).click();
  };

  const handleRemoveImage = () => {
    setFormValues({ ...formValues, image: "" });
    setFiles(null);
    const inputElement = document.querySelector('.user_editor_wrapper input[type="file"]');
    if (inputElement) (inputElement as HTMLInputElement).value = '';
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = () => {
    // Validate required fields
    if (!formValues.name?.trim()) {
      enqueueSnackbar('Name is required', { variant: 'error' });
      return;
    }
    if (!formValues.email?.trim()) {
      enqueueSnackbar('Email is required', { variant: 'error' });
      return;
    }
    
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formValues.email)) {
      enqueueSnackbar('Invalid email format', { variant: 'error' });
      return;
    }
    
    if (!user_id && !formValues.password?.trim()) {
      enqueueSnackbar('Password is required for new users', { variant: 'error' });
      return;
    }

    setLoading(true);
    const body = new FormData();
    body.append("formValues", JSON.stringify(formValues));
    if (files) {
      body.append("image", files);
    }
    axios.post(ProjectConfig.api_url + "/users/addedit", body, {
        headers: {
          "ltkn": localStorage.getItem("ltkn"),
          "Content-Type": "multipart/form-data"
        },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.status === "success") {
          enqueueSnackbar('Success', { variant: 'success' });
          setOpenEditor(false);
          loadList();
        } else {
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
      })
      .catch((err) => {
        console.error('Error creating/updating user:', err);
        const errorMessage = err.response?.data?.message || err.response?.data?.error || err.message || 'Error creating/updating user. Please try again.';
        enqueueSnackbar(errorMessage, { variant: 'error' });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  console.log("formValues", formValues);
  return (
    <Dialog 
      open={openEditor}
      onClose={() => setOpenEditor(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      PaperProps={{ sx: { borderRadius: "1.25rem" } }}
    >
      <div className="DialogContainer user_editor_wrapper">
        <div className="ModuleWrapper">
          <div className="boxContainerHeader">
            <div className="dialog_container_title">
              <h2 className="dialog_title">Add Penni Cart Team Member</h2>
              <h3 className="dialog_subtitle">Profile</h3>
            </div>
          </div>

          <div className="dialogFormContainer">
            <div className="users_editor_form">

              <div className="account_logo_wrapper">
                <ImageUploader
                  className="account_logo"
                  image={formValues.image}
                  setImage={(newImage) => setFormValues({ ...formValues, image: newImage })}
                  setFiles={setFiles}
                  acceptedFormats={["png", "jpg", "jpeg"]}
                  maxSizeInMB={3}
                  onClear={() => console.log("Image cleared")}
                />

                <div className="account_logo_buttons">
                  <span className="external_label">Profile Picture</span>
                  <div className="welcome_upload_button_wrapper">
                    <Button
                      variant="outlined"
                      onClick={triggerFileInput}
                      startIcon={<PiUploadSimpleLight size={20} color="#B9B9B9" />}
                      className="welcome_upload_button"
                      size="small"
                    >
                      {!formValues.image ? "Upload Image" : "Replace Image"}
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={handleRemoveImage}
                      className="welcome_remove_button"
                      size="small"
                    >
                      Remove
                    </Button>
                  </div>
                  <div className="welcome_popup_tip">*.png, *.jpg files up to 3MB</div>
                </div>
              </div>

              
              <div className="textfield_wrapper">
                <InputLabel className="external_label">Name</InputLabel>
                <TextField
                  fullWidth
                  name="name"
                  value={formValues.name}
                  onChange={handleInputChange}
                />
              </div>
              {/* <div className="textfield_wrapper">
                <InputLabel className="external_label">Last Name</InputLabel>
                <TextField
                  fullWidth
                  name="lastname"
                  value={formValues.lastname}
                  onChange={handleInputChange}
                />
              </div> */}
              <div className="textfield_wrapper">
                <InputLabel className="external_label">Email</InputLabel>
                <TextField
                  fullWidth
                  name="email"
                  autoComplete="off"
                  value={formValues.email}
                  onChange={handleInputChange}
                />
              </div>
              <div className="textfield_wrapper">
                <InputLabel className="external_label">Password</InputLabel>
                <TextField
                  fullWidth
                  name="password"
                  autoComplete="new-password"
                  type={showPassword ? "text" : "password"}
                  value={formValues.password}
                  onChange={handleInputChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleTogglePasswordVisibility}
                          edge="end"
                        >
                          {showPassword ? <PiEyeSlash size={20} /> : <PiEyeLight size={20} />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="textfield_wrapper">
                <InputLabel className="external_label">Role</InputLabel>
                  <Form.Field>
                    <Dropdown
                    fluid
                    selection
                    className="dropdown_su"
                    options={[
                      { key: '1', text: 'Super Admin', value: '100' },
                      { key: '2', text: 'Admin', value: '101' },
                      { key: '3', text: 'Analyst', value: '102' },
                      ] 
                    }
                    value={formValues.role_id.toString()}
                    onChange={(e, { value }) => {
                      setFormValues({
                        ...formValues,
                        role_id: value,
                      });
                    }
                    }
                    />
                    
                </Form.Field>
              </div>
              {/* <div className="textfield_wrapper">
                <InputLabel className="external_label">Status</InputLabel>
                <ISwitch
                  label="Active"
                  checked={formValues.is_active}
                  name="is_active"
                  onChange={(e: any) => {
                    setFormValues({
                      ...formValues,
                      is_active: e.target.checked,
                    });
                  }}
                />
              </div> */}
              
            </div>
          </div>
        </div>
      </div>

      <div className="dialogButtons">
        <Button
          onClick={handleSubmit}
          variant="contained"
          className="button_1"
        >
          {formValues.user_id === "null" ? "Create user" : "Save"}
        </Button>
        <Button
          onClick={() => setOpenEditor(false)}
          variant="contained"
          color="secondary"
          className="button_secondary"
        >
          Cancel
        </Button>
      </div>
    </Dialog>
  );
}
